export const decodeUtm = (value) => {
    return value.replaceAll('+', ' ');
};
